import { render, staticRenderFns } from "./post_add_dialog.vue?vue&type=template&id=363aaac3&"
import script from "./post_add_dialog.vue?vue&type=script&lang=js&"
export * from "./post_add_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports